// removed by extract-text-webpack-plugin
module.exports = {"phone":"Phone__phone___2fFHN"};